import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

const EspacePartenaires = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <section className="py-20 bg-stone-50 min-h-screen flex items-center">
        <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 w-full text-center">
          <h1 className="text-2xl font-bold mb-4">Espace Partenaires</h1>
          <p className="text-slate-600 mb-6">
            Cette page a été remplacée par le nouveau portail partenaires.
          </p>
          <Button asChild>
            <Link to="/partenaires">
              Accéder au nouveau portail partenaires
            </Link>
          </Button>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default EspacePartenaires;